"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fallbackLanguageURLsToHome = exports.homeFallback = exports.mapLinksToLanguageUrls = exports.createRouteLanguageUrls = exports.omitFallbackLinks = exports.PAGE_TYPE_HOME = void 0;
const fromPairs_1 = __importDefault(require("lodash/fp/fromPairs"));
const keyBy_1 = __importDefault(require("lodash/fp/keyBy"));
const map_1 = __importDefault(require("lodash/fp/map"));
const mapValues_1 = __importDefault(require("lodash/fp/mapValues"));
const omitBy_1 = __importDefault(require("lodash/fp/omitBy"));
const pipe_1 = __importDefault(require("lodash/fp/pipe"));
const toPairs_1 = __importDefault(require("lodash/fp/toPairs"));
const libs_router_config_1 = require("@hotelplan/libs.router-config");
const fdr_lib_i18n_lang_config_1 = require("@hotelplan/fdr.lib.i18n.lang-config");
exports.PAGE_TYPE_HOME = `HOME`;
exports.omitFallbackLinks = (0, omitBy_1.default)(l => l === null || l === void 0 ? void 0 : l.__fallback);
function createRouteLanguageUrls(routeProp) {
    const { routeId, params, origin } = routeProp;
    const [protocol, domain] = origin.split('//');
    const routeByLang = (0, keyBy_1.default)(`locale`)((0, libs_router_config_1.getRoutesById)(routeId) || []);
    return (0, mapValues_1.default)(route => {
        const routeOrigin = `${protocol}//${(route === null || route === void 0 ? void 0 : route.domain) || domain}`;
        try {
            return new URL(route.builder(params), routeOrigin).toString();
        }
        catch (e) {
            if (process.env.NODE_ENV !== 'production') {
                // eslint-disable-next-line no-console
                console.error(e);
            }
        }
        return '/';
    })(routeByLang);
}
exports.createRouteLanguageUrls = createRouteLanguageUrls;
function mapLinksToLanguageUrls(origin, routeLanguageUrls, languageLinksMap) {
    return (0, pipe_1.default)(toPairs_1.default, (0, map_1.default)(([lang, link]) => {
        const routeUrl = routeLanguageUrls[lang];
        const uri = (link === null || link === void 0 ? void 0 : link.uri) || routeUrl;
        const routeOrigin = routeUrl ? routeUrl : origin;
        return [lang, new URL(uri, routeOrigin).toString()];
    }), fromPairs_1.default)(languageLinksMap);
}
exports.mapLinksToLanguageUrls = mapLinksToLanguageUrls;
exports.homeFallback = Object.fromEntries(fdr_lib_i18n_lang_config_1.languageList.map(lang => {
    const route = (0, libs_router_config_1.getRouteByPageTypeLocale)(exports.PAGE_TYPE_HOME, lang);
    return [
        lang,
        {
            uri: route === null || route === void 0 ? void 0 : route.builder({}),
            __fallback: true,
        },
    ];
}));
function fallbackLanguageURLsToHome(langUrls) {
    return Object.fromEntries(fdr_lib_i18n_lang_config_1.languageList.map(lang => {
        var _a;
        return [lang, ((_a = langUrls[lang]) === null || _a === void 0 ? void 0 : _a.uri) ? langUrls[lang] : exports.homeFallback[lang]];
    }));
}
exports.fallbackLanguageURLsToHome = fallbackLanguageURLsToHome;
//# sourceMappingURL=lang.utils.js.map